import React, { Component } from 'react';

import { Grid, Header } from 'semantic-ui-react';

import LeverPane from './leverPane.js';

import Wrapper from '../wrapper';

class ModelLevers extends Component {
  render() {
    return (
      <Wrapper>
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column>
                <Header as='h2'> Defining the city's future mobility paradigm </Header>
                <LeverPane/>
              </Grid.Column>
            </Grid.Row>
          </Grid>
      </Wrapper>
    );
  }
}

export default ModelLevers;



// WEBPACK FOOTER //
// ./src/pages/modelLevers/index.js